import React from 'react';
import { BookOpen, Settings, Moon, Sun } from 'lucide-react';

interface BottomNavProps { 
  onSettingsClick: () => void; 
  onGuideClick: () => void;
  activeView: string;
  isDarkMode: boolean;
  toggleTheme: () => void;
}

const BottomNav: React.FC<BottomNavProps> = ({ onSettingsClick, onGuideClick, activeView, isDarkMode, toggleTheme }) => {
  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-800 border-t border-gray-100 dark:border-slate-700 px-6 py-4 rounded-t-3xl shadow-[0_-10px_25px_-5px_rgba(0,0,0,0.1)] z-50">
      <div className="flex justify-around items-center max-w-md mx-auto">
        
        {/* Guide Button - Enhanced for visibility */}
        <button 
          onClick={onGuideClick}
          className={`flex flex-col items-center gap-1.5 transition-all duration-300 relative ${activeView === 'guide' ? 'scale-110' : 'hover:scale-105'}`}
        >
          <div className={`w-14 h-9 rounded-2xl flex items-center justify-center transition-all duration-300 ${
            activeView === 'guide' 
              ? 'bg-blue-600 text-white shadow-md' 
              : 'bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 guide-attention-glow'
          }`}>
            <BookOpen size={22} className={activeView !== 'guide' ? 'animate-soft-bounce' : ''} />
          </div>
          <span className={`text-[11px] font-bold font-myanmar transition-colors ${
            activeView === 'guide' 
              ? 'text-blue-700 dark:text-blue-400' 
              : 'text-blue-600 dark:text-blue-500'
          }`}>
            Guide (အသုံးပြုပုံ)
          </span>
          {activeView !== 'guide' && (
            <span className="absolute -top-1 -right-1 flex h-3 w-3">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-3 w-3 bg-blue-500"></span>
            </span>
          )}
        </button>

        {/* Dark Mode Button */}
        <button 
          onClick={toggleTheme}
          className="flex flex-col items-center gap-1 text-gray-400 dark:text-gray-500 hover:text-gray-800 dark:hover:text-white transition-colors"
        >
          <div className="w-12 h-8 flex items-center justify-center">
            {isDarkMode ? <Sun size={24} /> : <Moon size={24} />}
          </div>
          <span className="text-[10px] font-bold">{isDarkMode ? 'Light' : 'Dark'}</span>
        </button>

        {/* Settings / Admin Button */}
        <button 
          onClick={onSettingsClick} 
          className={`flex flex-col items-center gap-1 ${activeView === 'admin' ? 'text-blue-600' : 'text-gray-400 dark:text-gray-500 hover:text-gray-600'}`}
        >
          <div className="w-12 h-8 flex items-center justify-center">
             <Settings size={22} />
          </div>
          <span className="text-[10px] font-bold opacity-0">Admin</span>
        </button>
      </div>
    </div>
  );
};

export default BottomNav;